<template>
    <div>
        <div>
            <img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/belt/8.png" style="width: 100%" alt="">
        </div>
        <div class="info-father">
            <div class="index-div-content  product-info-div-no-padding">
                <div>
                    <h3 class="margin-bottom-10 center color-1B1B1B font-28 ">
                        <img src="../../../assets/img/1.png" width="31" alt=""> <span style="margin:0 20px">产品功能</span>
                        <img
                                src="../../../assets/img/2.png" width="31" alt="">
                    </h3>
                </div>
                <div class="product_info">
                    <div><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/belt/7.png" width="140" alt=""></div>
                    <div><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/belt/6.png" width="140" alt=""></div>
                    <div><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/belt/5.png" width="140" alt=""></div>
                    <div><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/belt/4.png" width="140" alt=""></div>
                </div>
            </div>
        </div>
        <div class="index-div-content  product-info-div-no-padding">
            <el-row type="flex" justify="center" class="margin-top-20 background-white  product-info-div-flex">
                <el-col :xs="24" :sm="12"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/belt/1.png" style="width:100%" alt=""></el-col>
                <el-col :xs="24" :sm="12">
                    <div class="padding-40">
                        <h3 class="margin-bottom-20 margin-top-20  color-1B1B1B font-28 ">
                            <span>皮带撕裂智能预警</span>
                        </h3>
                        <div class="robot-info-splice"></div>
                        <p class="margin-top-20">
                            24小时自动检测、智能识别、自动停皮带的皮带纵向撕裂预警设备，根据皮带机启停进行智能检测，撕裂发生1秒内响应并停止皮带运行。
                        </p>
                    </div>

                </el-col>
            </el-row>
            <el-row type="flex"  justify="center" class="margin-top-20 background-white  product-info-div-flex">
                <el-col :xs="24" :sm="0"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/belt/2.png" style="width:100%" alt=""></el-col>
                <el-col :xs="24" :sm="12">
                    <div class="padding-40">
                        <h3 class="margin-bottom-20 margin-top-20  color-1B1B1B font-28 ">
                            <span>双重检测，根除误报</span>
                        </h3>
                        <div class="robot-info-splice"></div>
                        <p class="margin-top-20">
                            双相机双镭射检测，可以实现多重验证、多重根除误报。
                        </p></div>
                </el-col>
                <el-col :xs="0" :sm="12"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/belt/2.png" style="width:100%" alt=""></el-col>
            </el-row>
            <el-row type="flex"  justify="center" class="margin-top-20 background-white  product-info-div-flex">
                <el-col :xs="24" :sm="12"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/belt/3.png" style="width:100%" alt=""></el-col>
                <el-col :xs="24" :sm="12">
                    <div class="padding-40">
                        <h3 class="margin-bottom-20 margin-top-20  color-1B1B1B font-28 ">
                            <span>双相机双镭射检测，可以实现多重验证、多重根除误报。</span>
                        </h3>
                        <div class="robot-info-splice"></div>
                        <p class="margin-top-20">
                            应用了目前最先进的图像处理技术，独特的算法确保从复杂的皮带表面快速、准确提取出撕裂特征。
                        </p></div>
                </el-col>
            </el-row>
        </div>
        <div class="background-white margin-top-20">
            <div >
                <div class="index-div-content  product-info-div-no-padding   ">

                    <h3 class="margin-bottom-10 center color-1B1B1B font-28 ">
                        <img src="../../../assets/img/1.png" width="31" alt=""> <span style="margin:0 20px">应用案例</span>
                        <img
                                src="../../../assets/img/2.png" width="31" alt="">
                    </h3>
                    <div>
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="12">
                                <div>
                                    <video-component video-url="https://MK体育 - MK(中国)一站式服务官方网站-video.oss-cn-beijing.aliyuncs.com/video/%E5%AE%89%E5%BE%BD%E6%B1%A0%E6%92%95%E8%A3%82%E6%A3%80%E6%B5%8B%E8%A7%86%E9%A2%911.mp4"/>
                                    <div class="video-content">案例1：安徽池州某皮带纵向撕裂检测</div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <div>
                                    <video-component1 video-url="https://MK体育 - MK(中国)一站式服务官方网站-video.oss-cn-beijing.aliyuncs.com/video/%E5%AE%89%E5%BE%BD%E6%B1%A0%E6%92%95%E8%A3%82%E6%A3%80%E6%B5%8B%E8%A7%86%E9%A2%912.mp4"/>
                                    <div class="video-content">案例2：安徽池州某皮带纵向撕裂检测</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div style="height: 20px">      </div>
                </div>
            </div>

        </div>

    </div>


</template>

<script>
    import VideoComponent from "../../commom/VideoComponent";
    import VideoComponent1 from "../../commom/VideoComponent";

    export default {
        name: "belt",
        components:{VideoComponent,VideoComponent1},
    }
</script>

<style scoped>

</style>